import { gql } from "@apollo/client";
export const TransactionsUpdateOne = gql `
  mutation TransactionsUpdateOne(
    $id: ObjectId!
    $document: TransactionUpdateInput!
  ) {
    TransactionsUpdateOne(_id: $id, document: $document) {
      _id
      amount
      company {
        _id
        name
      }
      createdAt
      createdById
      dueDate
      externalId
      isCompleted
      type
      notes
    }
  }
`;
